import React from "react";

const SVGHeader = (<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="50" height="50" rx="15" fill="#3A56DF"/>
        <path
            d="M26.7778 18.0001V17.0001C26.7778 15.6194 27.8971 14.5001 29.2778 14.5001H38.5001C39.8808 14.5001 41.0001 15.6194 41.0001 17.0001V36.5001C41.0001 37.8808 39.8808 39.0001 38.5001 39.0001H29.2778C27.8971 39.0001 26.7778 37.8808 26.7778 36.5001V35.5001"
            stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <path
            d="M23.2222 14.5V13.5C23.2222 12.1193 22.1029 11 20.7222 11H11.4999C10.1192 11 8.99995 12.1193 8.99995 13.5V33C8.99995 34.3807 10.1192 35.5 11.4999 35.5H20.7222C22.1029 35.5 23.2222 34.3807 23.2222 33V32"
            stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="18.1393" cy="23.8621" r="1.5" transform="rotate(15 18.1393 23.8621)" fill="white"/>
        <circle cx="25.7887" cy="25.8797" r="1.5" transform="rotate(15 25.7887 25.8797)" fill="white"/>
        <circle cx="33.0172" cy="27.7865" r="1.5" transform="rotate(15 33.0172 27.7865)" fill="white"/>
        <path d="M26.7778 18H40.5556" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.2222 14.5001H9.44439" stroke="white" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
        <path d="M26.7778 35.5H40.5556" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.2222 31.9999H9.44439" stroke="white" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
    </svg>
)

export default SVGHeader